/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type LatestCustomerCateringRequestVariables = Types.Exact<{
  id: Types.InputMaybe<Types.Scalars['Int']>
}>

export type LatestCustomerCateringRequest = {
  __typename: 'Query'
  cateringRequests: {
    __typename: 'CateringRequestCollection'
    records: Array<{
      __typename: 'CateringRequest'
      id: number
      cateringType: string
      attendees: number
      fullAddress: string
      startAt: any
      endAt: any
      additionalInstructions: string | null
      foodPreferences: string | null
      preferredContactMethod: Types.CateringPreferredContactMethod
      customerTotalBudget: { __typename: 'Money'; cents: number }
      mealParts: Array<{
        __typename: 'CateringMealPart'
        id: number
        name: string
        count: number
      }>
    }>
  }
}

export const LatestCustomerCateringRequestDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LatestCustomerCateringRequest' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cateringRequests' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ListValue',
                  values: [
                    {
                      kind: 'ObjectValue',
                      fields: [
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'direction' },
                          value: { kind: 'EnumValue', value: 'desc' }
                        },
                        {
                          kind: 'ObjectField',
                          name: { kind: 'Name', value: 'field' },
                          value: { kind: 'EnumValue', value: 'created_at' }
                        }
                      ]
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'page' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '1' }
                    }
                  ]
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filter' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'id' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'id' }
                      }
                    }
                  ]
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'records' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'cateringType' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'attendees' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'customerTotalBudget' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'cents' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullAddress' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'mealParts' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'id' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'name' }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'count' }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'startAt' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'endAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'additionalInstructions' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'foodPreferences' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'preferredContactMethod' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode

/**
 * __useLatestCustomerCateringRequest__
 *
 * To run a query within a React component, call `useLatestCustomerCateringRequest` and pass it any options that fit your needs.
 * When your component renders, `useLatestCustomerCateringRequest` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLatestCustomerCateringRequest({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLatestCustomerCateringRequest(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    LatestCustomerCateringRequest,
    LatestCustomerCateringRequestVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LatestCustomerCateringRequest,
    LatestCustomerCateringRequestVariables
  >(LatestCustomerCateringRequestDocument, options)
}
export function useLatestCustomerCateringRequestLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LatestCustomerCateringRequest,
    LatestCustomerCateringRequestVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LatestCustomerCateringRequest,
    LatestCustomerCateringRequestVariables
  >(LatestCustomerCateringRequestDocument, options)
}
export type LatestCustomerCateringRequestHookResult = ReturnType<
  typeof useLatestCustomerCateringRequest
>
export type LatestCustomerCateringRequestLazyQueryHookResult = ReturnType<
  typeof useLatestCustomerCateringRequestLazyQuery
>
export type LatestCustomerCateringRequestQueryResult = Apollo.QueryResult<
  LatestCustomerCateringRequest,
  LatestCustomerCateringRequestVariables
>
